/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * App.js
 */

import React from 'react';

// Animate On Scroll
import AOS from 'aos';

// Containers
import PageFooter from './containers/PageFooter';
import PageHeader from './containers/PageHeader';
import ScrollToTop from './containers/ScrollToTop';
import Section from './containers/sections';

// Animate On Scroll Styles
import 'aos/dist/aos.css';

// Custom styles
import './assets/scss/styles.scss';

// Data
import { NAVBAR } from './data/Navbar';
import { PAGEFOOTER } from './data/PageFooter';
import { PAGEHEADER } from './data/PageHeader';
import { SECTIONS } from './data/Sections';

function App() {
  
  // Animation On Scroll
  // https://github.com/michalsnik/aos
  AOS.init({
    duration: 1200,
  });

  return (
    <div className="wrapper">
      <PageHeader navbar={NAVBAR} slider={PAGEHEADER} />
      
      <Section sectionData={SECTIONS.thehouse} />
      <Section sectionData={SECTIONS.services} />
      <Section sectionData={SECTIONS.about} />
      <Section sectionData={SECTIONS.rooms} />
      <Section sectionData={SECTIONS.tovisit} />
      <Section sectionData={SECTIONS.photos} />
      <Section sectionData={SECTIONS.contact} />
      
      <PageFooter footer={PAGEFOOTER} />
      <ScrollToTop />
    </div>
  );
}

export default App;
